import React from 'react';
import { createRoot } from 'react-dom/client';
import PortalListing from './App';

const elementContainer = document.querySelector<HTMLElement>('#portal-listing-root');

export const CALENDAR_DATE_FACET = elementContainer?.dataset?.calendarFacetKey
  ? elementContainer.dataset.calendarFacetKey
  : null;

export const CALENDAR_RESULTS_DATE_FACET = elementContainer?.dataset?.calendarResultsFacetKey
  ? elementContainer.dataset.calendarResultsFacetKey
  : null;

if (elementContainer) {
  const root = createRoot(elementContainer);
  root.render(<PortalListing />);
}
